{
    "Messages_Type_Label": "Tipo di messaggio",
    "Messages_Language_Label": "Lingua",
    "Messages_Language_DefaultOption": "Predefinito \/ Ripiego",
    "Messages_Subject_Label": "Soggetto",
    "Messages_PlainBody_Label": "Corpo (testo semplice)",
    "Messages_HtmlBody_Label": "Corpo (HTML)",
    "Messages_NewLocale_Info": "Quando salvi, verrà creata una nuova voce di messaggio per questa lingua.",
    "Messages_Action_Save": "Salva",
    "Messages_Action_Revert": "Ripristina",
    "Messages_Action_Delete": "Eliminare",
    "Messages_DiscardChanges_Prompt": "Annullare le modifiche non salvate?",
    "Messages_DiscardChanges_Confirm": "Scarta le modifiche",
    "Messages_DiscardChanges_Cancel": "Continua a modificare",
    "Messages_Save_Success": "Messaggio salvato.",
    "Messages_Save_Error": "Impossibile salvare il messaggio.",
    "Messages_Delete_Success": "Messaggio eliminato.",
    "Messages_Delete_Error": "Impossibile eliminare il messaggio.",
    "NAME": "Lingua dei messaggi"
}